<script setup lang="ts">
const route = useRoute()
const { $switchRoute } = useI18n()

useHead({ title: 'Blog' })

const limitPerPage = 5
const page = +(route.params.page || 1)
const tags = route.params.tags?.toString()
const q = route.params.q?.toString() || ''
const _q = ref(q)

const { pending: isFetching, data, error } = await useFetch(() => '/api/blog/posts', { key: `blog-${page}-${tags || 'notags'}-${q || 'noq'}`, params: { page, q, tags, limit: limitPerPage } })

watchEffect(() => {
  if (error.value) {
    throw createError({
      statusCode: 500,
      message: 'Nepodařilo se načíst články',
      fatal: true,
    })
  }
})

const total = computed(() => data.value?.meta.filter_count ?? 0)
const posts = computed(() => data.value?.data ?? [])

function search () {
  $switchRoute(`/blog/${_q.value ? `q-${_q.value}` : ''}`)
}
</script>

<template>
  <div fubex-container mb-44px scroll-smooth>
    <div flex flex-col gap-16px items-center text-center mt-32px md:mt-56px>
      <h1 id="blogAnchor" heading1 text-neutral-900 font-700>
        Blog
      </h1>
      <h3 text-neutral-900 paragraph-md max-w-648px>
        Pravidelně přinášíme články ze světa kryptoměn, blockchainu, NFT, bezpečnosti, technologií a byznysu.
      </h3>
    </div>
    <div w-full mt-24px lg:mt-48px grid grid-cols="lg:3 1" lg:flex-row gap-30px relative>
      <div col-span-2>
        <div v-if="!isFetching" w-full>
          <div v-auto-animate flex flex-col gap-24px min-h-50vh w-full>
            <div lg:hidden block>
              <BlogSearch v-model="_q" @search="search()" />
            </div>
            <div v-if="posts.length > 0" v-auto-animate flex flex-col gap-24px w-full>
              <BlogPost v-for="(item, index) in posts" :key="index" :post="item" />
            </div>
            <div v-else flex items-center justify-center pt-80px>
              <h3 heading3 text-center>
                ...Žádné příspěvky nebyly nalezeny
              </h3>
            </div>
            <div v-if="total && total > limitPerPage" flex justify-center my-40px>
              <UPagination :model-value="page" :page-count="limitPerPage" :total="total" :ui="{ rounded: 'first-of-type:rounded-s-md last-of-type:rounded-e-md' }" @update:model-value="(val: number) => $switchRoute({ params: { page: val } })">
                <template #prev>
                  <div px-8px>
                    <FButton name="page-prev" variant="text" :disabled="page <= 1" :to="{ params: { page: page - 1 } }">
                      <UnoIcon i-fubex-chevron-left-two h-14px w-14px />
                    </FButton>
                  </div>
                </template>
                <template #next>
                  <div px-8px>
                    <FButton name="page-next" variant="text" :disabled="page >= total / limitPerPage" :to="{ params: { page: page + 1 } }">
                      <UnoIcon i-fubex-chevron-right-two h-14px w-14px />
                    </FButton>
                  </div>
                </template>
              </UPagination>
            </div>
          </div>
        </div>
        <div v-else w-full flex flex-col gap-24px>
          <USkeleton v-for="item in limitPerPage" :key="item" h-228px w-full />
        </div>
      </div>
      <div flex flex-col gap-30px self-start max-w-400px w-full md:m-auto lg-m-0 mb-48px>
        <div lg:block hidden>
          <BlogSearch v-model="_q" @search="search()" />
        </div>
        <BlogTags />
      </div>
    </div>
    <WidgetNewsletter mt-32px />
  </div>
</template>
